<template>
  <div class="container">
    <section id="editContent" class="columnContainer categoryList">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.floating}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <FloatingList
              :activeLinkId="linkInfo.id"
              :locale="locale"
              :list="list"
              :bannerStyle="bannerStyle"
              :bannerActiveStyle="bannerActiveStyle"
              @updateList="updateFloatingList"
              @setMode="onSetMode"
              @setEditLink="updateLink" />
          </div>
          <div class="flexInner">
          </div>
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <SetFloatingUnit
          :locale="locale"
          :link="linkInfo"
          :floatingPageData="floatingPageData"
          :mode="settingMode"
          @updateFloatingPage="updateFloatingPage" />
      </div></div>
    </section>
    <div id="setContent">
      <SetFloatingItem
        :locale="locale"
        :setting="floatingSetting"
        @updateSetting="updateFloatingSetting"
        @save="onSave" />
    </div>
  </div>
</template>

<script>
import FloatingList from '@/components/Floating/Tree.vue'
import SetFloatingItem from '@/components/Floating/SettingItem.vue'
import SetFloatingUnit from '@/components/Floating/SettingUnit.vue'
import {
  createDefaultBannerStyle,
  createDefaultBannerActiveStyle
} from '@/constants/floating'

export default {
  name: 'Floating',
  components: {
    FloatingList,
    SetFloatingItem,
    SetFloatingUnit
  },
  props: [
    'locale'
  ],
  computed: {
    floatingSetting () {
      return {
        active: this.active,
        mainOnly: this.mainOnly,
        bannerStyle: this.bannerStyle,
        bannerActiveStyle: this.bannerActiveStyle
      }
    },
    floatingPageData () {
      const id = this.linkInfo?.id
      if (!id) return null
      const item = this.list.find(x => x.id === id)
      return item?.floatingPageData || null
    },
    hasNoIcon () {
      return this.floating.list.filter(x => x.icon.trim() === '').length > 0
    }
  },
  async created () {
    const normalizeFloatingData = (res) => {
      const bannerStyle = {
        ...createDefaultBannerStyle(),
        ...(res?.bannerStyle || {}),
        ...(res?.position != null && {
          positionX: res.position,
          positionY: 'bottom'
        }),
        ...(res?.style && {
          axisY: res.style.axisY ?? false,
          marginX: String(res.style.positionLeftRight ?? '15'),
          marginY: String(res.style.positionBottom ?? '15'),
          size: String(res.style.size ?? '60')
        })
      }

      const bannerActiveStyle = {
        ...createDefaultBannerActiveStyle(),
        ...(res?.bannerActiveStyle || {})
      }

      return {
        active: res?.active ?? false,
        list: Array.isArray(res?.list) ? [...res.list] : [],
        mainOnly: res?.mainOnly ?? true,
        bannerStyle,
        bannerActiveStyle
      }
    }

    const res = await this.$store.dispatch('floating/getFloating')
    if (!res) return

    const normalized = normalizeFloatingData(res)

    this.active = normalized.active
    this.list = normalized.list
    this.mainOnly = normalized.mainOnly
    this.bannerStyle = normalized.bannerStyle
    this.bannerActiveStyle = normalized.bannerActiveStyle
  },
  mounted () {
  },
  data () {
    return {
      settingMode: '',
      linkInfo: {},

      active: false,
      list: [],
      mainOnly: false,
      bannerStyle: createDefaultBannerStyle(),
      bannerActiveStyle: createDefaultBannerActiveStyle()
    }
  },
  methods: {
    onSetMode (mode) {
      this.settingMode = mode
    },
    updateLink (link) {
      this.linkInfo = link || {}
    },
    updateFloatingList (nextList) {
      this.list = Array.isArray(nextList) ? [...nextList] : []
    },
    updateFloatingPage ({ id, floatingPageData }) {
      const index = this.list.findIndex(x => x.id === id)
      if (index === -1) return

      const nextItem = {
        ...this.list[index],
        floatingPageData: floatingPageData || null
      }

      const nextList = [...this.list]
      nextList.splice(index, 1, nextItem)
      this.list = nextList

      if (this.linkInfo?.id === id) {
        this.linkInfo = { ...nextItem }
      }
    },
    updateFloatingSetting (nextSetting) {
      this.active = nextSetting.active
      this.mainOnly = nextSetting.mainOnly
      this.bannerStyle = { ...nextSetting.bannerStyle }
      this.bannerActiveStyle = { ...nextSetting.bannerActiveStyle }
    },
    validateOnSave () {
      return true
    },
    onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const floatingData = {
          active: this.active,
          list: this.list,
          mainOnly: this.mainOnly,
          bannerStyle: this.bannerStyle,
          bannerActiveStyle: this.bannerActiveStyle
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('floating/setFloating', floatingData)
          .then(() => {
            this.$store.dispatch('floating/setFloatingData').then(() => {
              alert(this.locale.complete_save)
              this.$store.commit('onLoading', false)
            })
          })
      }
    }
  }
}
</script>
